import { clsx } from 'clsx';
import * as styles from './styles.css';
import { LinkButton } from '@cian/ui-kit';

interface IDetailsBtnLinkProps {
  link: string;
  withOutMargin?: boolean;
}

export const DetailsBtnLink: React.FC<IDetailsBtnLinkProps> = ({ link, withOutMargin = false }) => {
  return (
    <div className={clsx(styles['btn'], withOutMargin && styles['without-margin'])}>
      <LinkButton fullWidth href={link} target="_blank" size="M">
        Подробнее
      </LinkButton>
    </div>
  );
};
